import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';

export const POIDIRECTORIES_FETCH_DATA_INIT = createAction(
  'POIDIRECTORIES_FETCH_DATA_INIT'
);
export const POIDIRECTORIES_FETCH_DATA_SUCCESS = createAction(
  'POIDIRECTORIES_FETCH_DATA_SUCCESS'
);
export const POIDIRECTORIES_FETCH_DATA_FAIL = createAction(
  'POIDIRECTORIES_FETCH_DATA_FAIL'
);

export const POIDIRECTORIES_DELETE_POI_INIT = createAction(
  'POIDIRECTORIES_DELETE_POI_INIT'
);
export const POIDIRECTORIES_DELETE_POI_SUCCESS = createAction(
  'POIDIRECTORIES_DELETE_POI_SUCCESS'
);
export const POIDIRECTORIES_DELETE_POI_FAIL = createAction(
  'POIDIRECTORIES_DELETE_POI_FAIL'
);

export const POIDIRECTORIES_CLEAR_DATA = createAction(
  'POIDIRECTORIES_CLEAR_DATA'
);

export const POIDIRECTORIES_UPLOAD_POI_INIT = createAction(
  'POIDIRECTORIES_UPLOAD_POI_INIT'
);
export const POIDIRECTORIES_UPLOAD_POI_SUCCESS = createAction(
  'POIDIRECTORIES_UPLOAD_POI_SUCCESS'
);
export const POIDIRECTORIES_UPLOAD_POI_FAIL = createAction(
  'POIDIRECTORIES_UPLOAD_POI_FAIL'
);

export const fetchPoiDirectory = ({ search, siteId, page = 1, limit = 12 }) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(POIDIRECTORIES_FETCH_DATA_INIT());

    if (siteId) {
      let pois;
      try {
        pois = await Axios.get(`${url}/poiDirectory/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
          params: {
            siteId,
            page,
            limit,
            search,
          },
        });
      } catch (error) {
        let errorMessage;
        if (error.response) {
          errorMessage = error && error.response && error.response.data.message;
        }
        toastr.error('', errorMessage);
        return dispatch(POIDIRECTORIES_FETCH_DATA_FAIL({ error }));
      }
      const total = pois.data.total;
      pois = pois.data.assets;

      return dispatch(
        POIDIRECTORIES_FETCH_DATA_SUCCESS({
          list: pois,
          total: total,
        })
      );
    }
  };
};

export const deletePoiAsset = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(POIDIRECTORIES_DELETE_POI_INIT());
    try {
      await Axios.post(
        `${url}/poiDirectory/delete`,
        {
          id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        POIDIRECTORIES_DELETE_POI_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The poi asset was deleted.');

    if (typeof cb === 'function') cb();
    return dispatch(POIDIRECTORIES_DELETE_POI_SUCCESS({ id }));
  };
};

export const clearPoisData = () => {
  return (dispatch) => {
    dispatch(POIDIRECTORIES_CLEAR_DATA());
  };
};

export const uploadPoiAssets = ({ file, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(POIDIRECTORIES_UPLOAD_POI_INIT());

    // let createPoi;

    const asset = new FormData();
    asset.set('siteId', siteId);
    if (file) asset.append('file', file);

    try {
      await Axios.post(`${url}/poiDirectory/upload`, asset, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      toastr.error('', 'Please fill in all required fields');
      return dispatch(
        POIDIRECTORIES_UPLOAD_POI_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    if(typeof cb === 'function')cb();
    toastr.success('', 'Poi asset uploaded successfully');
    return dispatch(POIDIRECTORIES_UPLOAD_POI_SUCCESS());
  };
};
